


import React, { useState, useEffect } from 'react';
import {
  Box, Card, CardContent, Typography, Button, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper, Chip, TextField, MenuItem,
  IconButton, Grid, InputAdornment, Alert, Avatar, Tooltip, Badge,
  Skeleton, Fade, Divider, Stack
} from '@mui/material';
import {
  Add as AddIcon,
  Search as SearchIcon,
  Visibility as ViewIcon,
  FilterList as FilterIcon,
  Refresh as RefreshIcon,
  Download as DownloadIcon,
  TrendingUp,
  ShoppingCart,
  CheckCircle,
  Schedule,
  AttachMoney,
  Close as CloseIcon
} from '@mui/icons-material';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { fetchUserFromRedis } from "../AuthonticationPages/Register";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API;

const PurchaseOrderList = () => {
  const navigate = useNavigate();
  const [pos, setPOs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingPo, setLoadingPo] = useState(null);
  const [stats, setStats] = useState(null);
  const [error, setError] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  
  // Filters
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [paymentStatusFilter, setPaymentStatusFilter] = useState('');
  const [distributorFilter, setDistributorFilter] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  
  // Pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [total, setTotal] = useState(0);
  const [user,setUser]=useState(null);

  useEffect(() => {
    loadPOs();
    loadStats();
  }, [page, rowsPerPage, search, statusFilter, paymentStatusFilter, distributorFilter, dateFrom, dateTo]);

  const loadPOs = async () => {
    setLoading(true);
    setError('');
    try {
      const params = new URLSearchParams({
        skip: (page * rowsPerPage).toString(),
        limit: rowsPerPage.toString(),
      });
      
      if (search) params.append('search', search);
      if (statusFilter) params.append('status', statusFilter);
      if (paymentStatusFilter) params.append('payment_status', paymentStatusFilter);
      if (distributorFilter) params.append('distributor_id', distributorFilter);
      if (dateFrom) params.append('from_date', dateFrom);
      if (dateTo) params.append('to_date', dateTo);
      
      const response = await axios.get(`${API_BASE_URL}/purchase-orders?${params}`);
      setPOs(response.data.purchase_orders || []);
      setTotal(response.data.total || 0);
    } catch (error) {
      console.error('Error loading POs:', error);
      setError('Failed to load purchase orders. Please try again.');
    } finally {
      setLoading(false);
    }
  };
useEffect(() => {
    const loadUserData = async () => {
      const userId = sessionStorage.getItem("userId");
      const token = sessionStorage.getItem("token");
      if (!userId || !token) {
        setUser(null);
        return;
      }
      try {
        const userData = await fetchUserFromRedis(userId, token);
        setUser(userData || null);
      } catch (err) {
        console.error("Error fetching user from Redis:", err);
        setUser(null);
      }
    };
    loadUserData();
  },[])
  const loadStats = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/purchase-orders/stats`);
      setStats(response.data);
    } catch (error) {
      console.error('Error loading stats:', error);
    }
  };

  const getStatusColor = (status) => {
    const colors = {
      CREATED: 'default',
      SENT: 'info',
      PARTIALLY_RECEIVED: 'warning',
      RECEIVED: 'success',
      CANCELLED: 'error'
    };
    return colors[status] || 'default';
  };

  const getPaymentStatusColor = (status) => {
    const colors = {
      unpaid: 'error',
      partial: 'warning',
      paid: 'success'
    };
    return colors[status] || 'default';
  };

  const handleViewPO = (poId) => {
    navigate(`/purchase-orders/${poId}`);
  };

  const handleCreatePO = () => {
    navigate('/purchase-orders/create');
  };

  const handleRefresh = () => {
    loadPOs();
    loadStats();
  };
  const handlePoApproval=async (status, userId, po)=>{
    try{
    setLoadingPo(po.Id);
    const approvalStatus= await axios.put(`${API_BASE_URL}/purchase-orders/${po.id}/po-approval`, {
    approved_status: status,
    approved_by: userId
    });
    setPOs(prev =>
      prev.map(p =>
        p.id === po.id
          ? { ...p, approved_status: status }
          : p
      )
    );
  }
    catch (err) {
        console.error("Error fetching user from Redis:", err);
        
      }
      setLoadingPo(null);
  }
  const approveIcon=(po)=>{
      return(
        <IconButton
            size="small"
            onClick={() => handlePoApproval("approved", user.user_id,po)}
            sx={{
              backgroundColor: "#2E7D32",
              color: "white",
              "&:hover": { backgroundColor: "#1B5E20" },
              width: 32,
              height: 32,
            }}
            title="Approve User"
          >
            <CheckCircleIcon sx={{ fontSize: 18 }} />
          </IconButton>)
        }

  const rejectIcon=(po)=>{
      return(
        <IconButton
          size="small"
          onClick={() => handlePoApproval("rejected", user.user_id, po)}
          sx={{ 
            border: "1px solid #E0E0E0", 
            width: 32, 
            height: 32,
            color: "#C62828",
            "&:hover": { backgroundColor: "#FFEBEE" }
          }}
          title="Reject User"
        >
          <CancelIcon sx={{ fontSize: 18 }} />
        </IconButton>
      )
  }
 const handlePoActions = (po) => {
  if (po?.approved_status === "approved") {
    return (
      <>
      {rejectIcon(po)}
      </>
    );
  }
  // ⭐ If rejected
  if (po?.approved_status === "rejected") {
    return (
      <>
      {approveIcon(po)}
      </>
    );
  }
  if (po?.created_by==="SYSTEM" && (po.approved_status==="pending")){
    return (
      <>
        {approveIcon(po)}
        {rejectIcon(po)}
        </>
    );
  }

  return null; 
};
  const clearFilters = () => {
    setSearch('');
    setStatusFilter('');
    setPaymentStatusFilter('');
    setDistributorFilter('');
    setDateFrom('');
    setDateTo('');
  };

  const activeFiltersCount = [statusFilter, paymentStatusFilter, dateFrom, dateTo].filter(Boolean).length;

  const DRAWER_WIDTH = '300px';

  // Reusable Stat Card Component
  const StatCard = ({ title, value, icon: Icon, color, subtitle }) => (
    <Card 
      sx={{ 
        height: '100%',
        background: `linear-gradient(135deg, ${color}15 0%, ${color}05 100%)`,
        border: `1px solid ${color}30`,
        transition: 'all 0.3s ease',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
        }
      }}
    >
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Box sx={{ flex: 1 }}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1, fontWeight: 500 }}>
              {title}
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: 700, color: color, mb: 0.5 }}>
              {value}
            </Typography>
            {subtitle && (
              <Typography variant="caption" color="text.secondary">
                {subtitle}
              </Typography>
            )}
          </Box>
          <Avatar sx={{ bgcolor: color, width: 48, height: 48 }}>
            <Icon />
          </Avatar>
        </Box>
      </CardContent>
    </Card>
  );

  return (
    <Box sx={{ 
      minHeight: '100vh', 
      bgcolor: '#f8f9fa',
      ml: { xs: 0, md: DRAWER_WIDTH },
      p: { xs: 2, sm: 3 }
    }}>
      {/* Header Section */}
      <Box sx={{ mb: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2, mb: 1 }}>
          <Box>
            <Typography variant="h4" sx={{ fontWeight: 700, color: '#1a1a1a', mb: 0.5 }}>
              Purchase Orders
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Manage and track all purchase orders
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 1.5 }}>
            <Tooltip title="Refresh data">
              <IconButton 
                onClick={handleRefresh}
                sx={{ 
                  bgcolor: 'white',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                  '&:hover': { bgcolor: '#f5f5f5' }
                }}
              >
                <RefreshIcon />
              </IconButton>
            </Tooltip>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={handleCreatePO}
              sx={{
                bgcolor: '#006D77',
                borderRadius:"10px",
                textTransform: 'none',
                fontWeight: 600,
                px: 3,
                boxShadow: '0 4px 12px rgba(37,99,235,0.25)',
                '&:hover': {
                  bgcolor: '#0A9396',
                  boxShadow: '0 6px 16px rgba(37,99,235,0.35)',
                }
              }}
            >
              New Purchase Order
            </Button>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => navigate('/StockSuggestions')}
              sx={{
                bgcolor: '#006D77',
                textTransform: 'none',
                fontWeight: 600,borderRadius:"10px",
                px: 3,
                boxShadow: '0 4px 12px rgba(37,99,235,0.25)',
                '&:hover': {
                  bgcolor: '#0A9396',
                  boxShadow: '0 6px 16px rgba(37,99,235,0.35)',
                },
              }}
            >
              Stock Suggestions
            </Button>
         
          </Box>
        </Box>
      </Box>

      {/* Error Alert */}
      <Fade in={!!error}>
        <Box sx={{ mb: 3 }}>
          {error && (
            <Alert 
              severity="error" 
              onClose={() => setError('')}
              sx={{ borderRadius: 2 }}
            >
              {error}
            </Alert>
          )}
        </Box>
      </Fade>

      {/* Statistics Cards */}
      {stats ? (
        <Grid container spacing={2.5} sx={{ mb: 3 }}>
          <Grid item xs={12} sm={6} lg={3}>
            <StatCard
              title="Total Purchase Orders"
              value={stats.total_pos}
              icon={ShoppingCart}
              color="#2563eb"
              subtitle="All time"
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <StatCard
              title="Total Value"
              value={`₹${(stats.total_amount || 0).toFixed(2).toLocaleString('en-IN')}`}
              icon={CurrencyRupeeIcon}
              color="#059669"
              subtitle="Grand total"
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <StatCard
              title="Pending Orders"
              value={(stats.by_status?.CREATED?.count || 0) + (stats.by_status?.SENT?.count || 0)}
              icon={Schedule}
              color="#f59e0b"
              subtitle="Awaiting receipt"
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <StatCard
              title="Completed"
              value={stats.by_status?.RECEIVED?.count || 0}
              icon={CheckCircle}
              color="#10b981"
              subtitle="Fully received"
            />
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={2.5} sx={{ mb: 3 }}>
          {[1, 2, 3, 4].map((i) => (
            <Grid item xs={12} sm={6} lg={3} key={i}>
              <Skeleton variant="rectangular" height={120} sx={{ borderRadius: 2 }} />
            </Grid>
          ))}
        </Grid>
      )}

      {/* Search and Filter Bar */}
      <Card sx={{ mb: 2.5, boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 2 }}>
        <CardContent sx={{ p: 2.5 }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                size="medium"
                placeholder="Search by PO number, distributor name..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: '#9ca3af' }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    bgcolor: '#f9fafb',
                    width: {
                      xs: '100%',
                      sm: 400,
                      md: 600,
                    },
                    '&:hover': {
                      bgcolor: 'white',
                    }
                  }
                }}

              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ display: 'flex', gap: 1.5, justifyContent: { xs: 'flex-start', md: 'flex-end' } }}>
                <Badge badgeContent={activeFiltersCount} color="white">
                  <Button
                    variant={showFilters ? 'contained' : 'outlined'}
                    startIcon={<FilterIcon />}
                    onClick={() => setShowFilters(!showFilters)}
                    sx={{ textTransform: 'none', fontWeight: 600 ,bgcolor:"#006D77",color:'white'}}
                    
                  >
                    Filters
                  </Button>
                </Badge>
                {activeFiltersCount > 0 && (
                  <Button
                    variant="outlined"
                    onClick={clearFilters}
                    sx={{ textTransform: 'none', fontWeight: 600 }}
                  >
                    Clear All
                  </Button>
                )}
              </Box>
            </Grid>
          </Grid>

          {/* Advanced Filters Section */}
          {showFilters && (
            <Fade in={showFilters}>
              <Box sx={{ mt: 2.5, pt: 2.5, borderTop: '1px solid #e5e7eb' }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      fullWidth
                      size="small"
                      select
                      label="Order Status"
                      sx={{
                        width: {
                          xs: '100%',
                          sm: 200,
                          md: 300,
                        },
                      }}
                      value={statusFilter}
                      onChange={(e) => setStatusFilter(e.target.value)}
                    >
                      <MenuItem value="">All Statuses</MenuItem>
                      <MenuItem value="CREATED">Created</MenuItem>
                      <MenuItem value="SENT">Sent</MenuItem>
                      <MenuItem value="PARTIALLY_RECEIVED">Partially Received</MenuItem>
                      <MenuItem value="RECEIVED">Received</MenuItem>
                      <MenuItem value="CANCELLED">Cancelled</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      fullWidth
                      size="small"
                      select
                      label="Payment Status"
                      value={paymentStatusFilter}
                      sx={{
                        width: {
                          xs: '100%',
                          sm: 200,
                          md: 300,
                        },
                      }}
                      onChange={(e) => setPaymentStatusFilter(e.target.value)}
                    >
                      <MenuItem value="">All Payment Status</MenuItem>
                      <MenuItem value="unpaid">Unpaid</MenuItem>
                      <MenuItem value="partial">Partial</MenuItem>
                      <MenuItem value="paid">Paid</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      fullWidth
                      size="small"
                      type="date"
                      label="From Date"
                      value={dateFrom}
                      onChange={(e) => setDateFrom(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      fullWidth
                      size="small"
                      type="date"
                      label="To Date"
                      value={dateTo}
                      onChange={(e) => setDateTo(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Fade>
          )}
        </CardContent>
      </Card>

      {/* Purchase Orders Table */}
      <Card sx={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 2 }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: '#f9fafb' }}>
                <TableCell sx={{ fontWeight: 700, color: '#374151' }}>PO Details</TableCell>
                <TableCell sx={{ fontWeight: 700, color: '#374151' }}>Date</TableCell>
                <TableCell sx={{ fontWeight: 700, color: '#374151' }}>Distributor</TableCell>
                <TableCell align="center" sx={{ fontWeight: 700, color: '#374151' }}>Items</TableCell>
                <TableCell align="right" sx={{ fontWeight: 700, color: '#374151' }}>Amount</TableCell>
                <TableCell align="center" sx={{ fontWeight: 700, color: '#374151' }}>Status</TableCell>
                <TableCell align="center" sx={{ fontWeight: 700, color: '#374151' }}>Payment</TableCell>
                <TableCell align="center" sx={{ fontWeight: 700, color: '#374151' }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                [...Array(5)].map((_, i) => (
                  <TableRow key={i}>
                    <TableCell colSpan={8}>
                      <Skeleton variant="rectangular" height={60} />
                    </TableCell>
                  </TableRow>
                ))
              ) : pos.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={8}>
                    <Box sx={{ textAlign: 'center', py: 6 }}>
                      <ShoppingCart sx={{ fontSize: 64, color: '#d1d5db', mb: 2 }} />
                      <Typography variant="h6" color="text.secondary" sx={{ mb: 1 }}>
                        No purchase orders found
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Try adjusting your filters or create a new purchase order
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ) : (
                pos.map((po) => (
                  <TableRow 
                    key={po.id} 
                    hover
                    sx={{ 
                      '&:hover': { bgcolor: '#f9fafb' },
                      cursor: 'pointer'
                    }}
                  >
                    <TableCell>
                      <Typography variant="body2" fontWeight="700" sx={{ color: '#1f2937' }}>
                        {po.po_number}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" sx={{ color: '#6b7280' }}>
                        {new Date(po.po_date).toLocaleDateString('en-IN', { 
                          day: 'numeric',
                          month: 'short',
                          year: 'numeric'
                        })}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" fontWeight="600" sx={{ color: '#1f2937' }}>
                        {po.distributor_name}
                      </Typography>
                      {po.distributor_contact && (
                        <Typography variant="caption" sx={{ color: '#9ca3af', display: 'block' }}>
                          {po.distributor_contact}
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell align="center">
                      <Chip 
                        label={po.items?.length || 0} 
                        size="small"
                        sx={{ 
                          bgcolor: '#eff6ff',
                          color: '#2563eb',
                          fontWeight: 600
                        }}
                      />
                    </TableCell>
                    <TableCell align="right">
                      <Typography variant="body2" fontWeight="700" sx={{ color: '#1f2937' }}>
                        ₹{(po.grand_total || 0).toLocaleString('en-IN')}
                      </Typography>
                      {po.balance > 0 && (
                        <Typography variant="caption" sx={{ color: '#dc2626', fontWeight: 600, display: 'block' }}>
                          Bal: ₹{po.balance.toLocaleString('en-IN')}
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell align="center">
                      <Chip
                        label={po.status.replace(/_/g, ' ')}
                        color={getStatusColor(po.status)}
                        size="small"
                        sx={{ 
                          fontWeight: 600,
                          textTransform: 'capitalize'
                        }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Chip
                        label={po.payment_status}
                        color={getPaymentStatusColor(po.payment_status)}
                        size="small"
                        sx={{ 
                          fontWeight: 600,
                          textTransform: 'capitalize'
                        }}
                      />
                    </TableCell>
                    <TableCell align="center">
                       {handlePoActions(po)}
                      <Tooltip title="View Details">
                        <IconButton
                          size="small"
                          sx={{ 
                            color: '#006D77',
                            '&:hover': { bgcolor: '#eff6ff' }
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleViewPO(po.id);
                          }}
                        >
                          <ViewIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination Footer */}
        <Box sx={{ 
          p: 2.5, 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          borderTop: '1px solid #e5e7eb',
          flexWrap: 'wrap',
          gap: 2
        }}>
          <Typography variant="body2" sx={{ color: '#6b7280', fontWeight: 500 }}>
            Showing {pos.length > 0 ? ((page * rowsPerPage) + 1) : 0} - {Math.min((page + 1) * rowsPerPage, total)} of {total} orders
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              variant="outlined"
              size="small"
              disabled={page === 0}
              onClick={() => setPage(page - 1)}
              sx={{ 
                textTransform: 'none',
                fontWeight: 600,
                minWidth: 90
              }}
            >
              Previous
            </Button>
            <Button
              variant="outlined"
              size="small"
              disabled={(page + 1) * rowsPerPage >= total}
              onClick={() => setPage(page + 1)}
              sx={{ 
                textTransform: 'none',
                fontWeight: 600,
                minWidth: 90
              }}
            >
              Next
            </Button>
          </Box>
        </Box>
      </Card>
    </Box>
  );
};

export default PurchaseOrderList;